export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4043e2e80590ef5b91dcf270859ce8e3dc204509a0&name=revalidateCommunity!'